// eslint-disable-next-line no-unused-vars
const canRequire = typeof __webpack_require__ === 'function';

module.exports =
{
    branding: 'heute', // 'heute', 'logo'
    theme: 'dark', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Tschernobyl – Die Atom-Katastrophe und ihre Folgen',
        // Beschreibung
        description: 'Was hat die Tschernobyl-Nuklearkatastrophe 1986 ausgelöst, welche Folgen sind entstanden und wie ist die aktuelle Lage? Ein Überblick in 3D.',
        // Bild
        image: 'https://3d.zdf.de/ukraine-tschernobyl-jahrestag/img/Tschernobyl-Link-Preview.jpg',
        // URL
        url: 'https://3d.zdf.de/ukraine-tschernobyl-jahrestag/',
    },
    tracking: {
        storyName: 'Tschernobyl2026',
        storyID: '3ds_tschernobyl',
        // Tracking deaktivieren
        // disabled: false,
    },
    babylon: {
        lightIntensity : 2,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [-1,1,90], // alpha, beta, radius
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [-10, 10, 0], // Wohin die Kamera blickt
            animationSpeed: 280, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [null, null],
            betaLimits: [0.1, 1.54],
            radiusLimits: [5, 100], // minCamRadius, maxCamRadius
            clipping: [2, 10000.0],
            fov: 0.8,
            invertRotation: false, // Kamera Steuerung umkehren für 360° Sphere Ansicht
            stopOnClick: false, // Kamera Animation stoppen, bei klick

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 25.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true,
        // Dauerhafte Hintergrund Musik
        //background: canRequire && require('./assets/audio/News_Loop3.mp3'),
    },
    objects:
    [

        {
            // Name des Objekts zur Ansteuerung
            name: "explosion",
            // GLB Dateiname im Ordner app/public/3d-models
            filename: "Explosion_Tschernobyl_200329.glb",
            options: {
                visible: false,
                scaling: [1, 1, -1],
                position: [-13.09, 0, 0],
                rotation: [0.5 * Math.PI, 0, 0],
                fade: false,
                animation: false,
                children:{
                    Yup2Zup:{
                        visible: true,
                        Explosion_GRP:{
                            Debris_GRP:{
                                visible: true,
                            },
                            Reaktor_4_Passform:{
                                //position: [1,0,0],
                                visible: false,
                                isEnabled: false,
                            },
                        },
                    },
                },


                // Nur initial, nicht per babylonState
                // OnClick Trigger
                // trigger: function () { }
            },
            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (explosion) // eslint-disable-line no-unused-vars
            {

            }
        },


        {
            name: "tschernobyl",
            filename: "tschernobyl2026.glb",
            options: {

                visible: true,
                scaling: [100, 100, -100],
                position: [0, 0, 0],
                fade: false,
                animation: false,
                children:{
                    root:{
                        NSC: {
                            Geo_Schienen_Sarkophag:{
                                visible:false
                            },
                            Anim_NSC:{
                                Geo_NSC_metall:{
                                    visible:false,
                                },
                                Geo_NSC_transparent:{
                                    visible:false,
                                },
                                Geo_Schattenplane_NSC:{
                                    visible:false,
                                },
                            }
                        },

                        Sarkophag: {
                            Geo_Beton_Sarkophag_Rost: {
                                visible: true,
                            },
                            Geo_Beton_Sarkophag: {
                                visible: true,
                            },
                            Geo_Schattenplane_Betonsarkophag: {
                                visible: true,
                            },

                        },

                        AKW: {
                            Text_Labels:{
                                Geo_Text_Berlin:{
                                    position: [0,0,0],
                                    scale:[0,0,0],
                                    visible: false,
                                    Berlin_Distance:{
                                        visible: false,
                                    }
                                },

                                Geo_Text_Kiew:{
                                    position: [0,0,0],
                                    scale:[0,0,0],
                                    visible: false,
                                    Kiew_Distance:{
                                        visible: false,
                                    }
                                },

                                Geo_Text_Moskau:{
                                    position: [0,0,0],
                                    scale:[0,0,0],
                                    visible: false,
                                    Moskau_Distance:{
                                        visible: false,
                                    }
                                },
                            }
                        },
                    },
                },

            },

            callback: function (tschernobyl) // eslint-disable-line no-unused-vars
            {

            let MAT_Innen = this.scene.getNodeByName("Geo_Reaktor_Damage_Innen").material;
            MAT_Innen.disableLighting = true;
            //MAT_Innen.separateCullingPass = true;

            let MAT_Schatten_all = this.scene.getNodeByName("Geo_Schattenplane_Betonsarkophag").material;
            MAT_Schatten_all.disableLighting = true;
            MAT_Innen.separateCullingPass = true;

            let MAT_Karte = this.scene.getNodeByName("Geo_Karte").material;
            MAT_Karte.disableLighting = true;

            let MAT_Strahl = this.scene.getNodeByName("Strahl_2").material;
            MAT_Strahl.disableLighting = true;
            MAT_Strahl.alphaMode = 1;

            let MAT_explosion = this.scene.getNodeByName("geo_explosion").material;
            MAT_explosion.disableLighting = true;
            //MAT_explosion.alphaMode = 1;
            MAT_explosion.separateCullingPass = true;

            let MAT_Typo = this.scene.getNodeByName("Geo_Text_Kiew").material;
            MAT_Typo.disableLighting = true;

            let MAT_Rost = this.scene.getNodeByName("Geo_Beton_Sarkophag_Rost").material;
            //MAT_Rost.disableLighting = true;
            MAT_Rost.separateCullingPass = true;

            let MAT_Beton = this.scene.getNodeByName("Geo_Beton_Sarkophag").material;
            //MAT_Rost.disableLighting = true;
            MAT_Beton.separateCullingPass = true;


            }
        },
    ]
};
